import React from "react";

import LoadingBar from "react-redux-loading-bar";
import { Provider } from "react-wrap-balancer";

import { AppHeader } from "@app/components";
import { Case, Switch, useAppFusion } from "@app/contexts";
import * as appConst from "@app/state/constants";

import { MENU_WIDTH } from "./components/drawer_sfx/background";
import { AuthRoutes } from "./pages";
import NotFusionAuth from "./pages/startup/NotFusionAuth";
import VerificationRequired from "./pages/startup/VerificationRequired";
import { SwsBuilderPrototype } from "./pages/superadmin/SwsBuilderPrototype";
import "./App.scss"

const headerHeight = appConst.SIZES.headerHeight;
const jgheaderHeight = appConst.SIZES.jgHeaderHeight;

function App() {
  const isSwsBuilderPrototypeMode = process.env.REACT_APP_SWSBUILDER_PROTOTYPE === "1";
  const { user, isAuthenticated, isVerifiedEmail, isRegisteredUser } =
    useAppFusion();

  // if (isSwsBuilderPrototypeMode) {
  //   return (
  //     <Provider>
  //       <div
  //         className="App"
  //         style={
  //           {
  //             "--header-height-px": `${headerHeight}px`,
  //             "--category-chooser-width": `${MENU_WIDTH}px`,
  //             "--jg-header-height": `${jgheaderHeight}px`,
  //             "--header-button-size": `${appConst.SIZES.headerButtonSize}px`,
  //           } as React.CSSProperties
  //         }
  //       >
  //         <SwsBuilderPrototype />
  //       </div>
  //     </Provider>
  //   );
  // }

  return (
    <Provider>
      <div
        className="App"
        style={
          {
            "--header-height-px": `${headerHeight}px`,
            "--category-chooser-width": `${MENU_WIDTH}px`,
            "--jg-header-height": `${jgheaderHeight}px`,
            "--header-button-size": `${appConst.SIZES.headerButtonSize}px`,
          } as React.CSSProperties
        }
      >
        <LoadingBar
          className={"loading1"}
          updateTime={100}
          maxProgress={95}
          progressIncrease={10}
        />
        <AppHeader />
        <Switch value={isAuthenticated}>
          <Case when={false}>
            <NotFusionAuth />
          </Case>
          <Case when={true}>
            <Switch value={isVerifiedEmail}>
              <Case when={false}>
                <VerificationRequired />
              </Case>
              <Switch value={isRegisteredUser}>
                <Case when={false}>
                  <p>{"set some database info"}</p>
                </Case>
                <Case when={true}>
                  <AuthRoutes />
                </Case>
              </Switch>
            </Switch>
          </Case>
        </Switch>
        {/* <p>&copy; 2003 - {new Date().getFullYear()} Softwiz Creation srl. All rights reserved.</p> */}
      </div>
    </Provider>
  );
}

export default App;
